var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"currency"},[(this.id!=1)?_c('span',[_vm._v(_vm._s(_vm.quantity)+" "),_c('currency-icon',{attrs:{"src":_vm.imageUrl,"alt":_vm.name,"title":_vm.description}})],1):_c('currency-coin',{attrs:{"description":_vm.description,"quantity":_vm.quantity,"showPosNeg":_vm.showPosNeg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }